export const ADD_VOUCHER = 'ADD_VOUCHER'
export const EDIT_VOUCHER = 'EDIT_VOUCHER'
export const SPAREPART_LIST = 'SPAREPART_LIST'
export const LAYANAN_LIST = 'LAYANAN_LIST'
